import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

const Footer = () => (
  <footer className="footer-container">
    <div className="footer">
      <div className="footer-social-holder">
        <div className="frame">
          <div className="footer-social-section">
            <div className="section-label">Follow Healthspan on...&nbsp;</div>
            <ul className="social-links">
              <li>
                <a
                  className="link-twitter"
                  href="https://twitter.com/Healthspan/"
                  title="Healthspan Twitter"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                >
                  Healthspan Twitter
                  <svg id="icon-twitter" viewBox="0 0 30 30">
                    <path
                      id="a"
                      d="M17.397 9.142c-1.355.476-2.211 1.705-2.114 3.05l.033.52-.542-.064c-1.973-.244-3.696-1.07-5.16-2.458L8.9 9.502l-.185.508c-.39 1.134-.14 2.33.672 3.136.434.444.336.508-.412.243-.26-.085-.487-.148-.509-.116-.076.074.184 1.038.39 1.419.282.53.856 1.049 1.485 1.356l.531.243-.628.011c-.607 0-.63.01-.564.233.217.689 1.073 1.42 2.027 1.737l.672.223-.586.339a6.255 6.255 0 0 1-2.904.784c-.488.01-.889.053-.889.084 0 .106 1.322.7 2.092.932 2.308.689 5.05.392 7.11-.783 1.463-.837 2.926-2.5 3.609-4.11.368-.858.737-2.426.737-3.178 0-.487.032-.55.64-1.133.357-.34.693-.71.758-.816.108-.201.098-.201-.455-.021-.921.317-1.051.275-.596-.202.336-.339.737-.953.737-1.133 0-.032-.163.021-.347.117-.195.106-.629.264-.954.36l-.585.18-.531-.35c-.293-.19-.705-.402-.921-.466-.553-.148-1.399-.127-1.897.043z"
                    ></path>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  className="link-facebook"
                  href="https://www.facebook.com/healthspan.co.uk "
                  title="Healthspan Facebook"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                >
                  Healthspan Facebook
                  <svg id="icon-facebook" viewBox="0 0 30 30">
                    <path d="M12.934 22.882v-8.16H11.25v-2.813h1.684v-1.688c0-2.294.952-3.659 3.654-3.659h2.25v2.813h-1.406c-1.052 0-1.122.393-1.122 1.127l-.004 1.407h2.548l-.298 2.812h-2.25v8.161h-3.372z"></path>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  className="link-youtube"
                  href="https://www.youtube.com/user/HealthspanUK/"
                  title="Healthspan YouTube"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                >
                  Healthspan YouTube
                  <svg id="icon-youtube" viewBox="0 0 30 30">
                    <path d="M14.997 14.49c0-.001 6.04.008 6.757.724.72.717.727 4.257.727 4.277 0 0-.006 3.559-.727 4.278-.717.716-6.757.731-6.757.731s-6.04-.015-6.758-.73c-.718-.718-.72-4.252-.72-4.279 0-.02.002-3.56.72-4.277.719-.716 6.758-.725 6.758-.725zM10.631 6l.718 2.65h.07L12.102 6h1.125L11.94 9.878v2.75h-1.107v-2.626L9.517 6h1.114zm3.073 1.952c.264-.225.62-.337 1.066-.337.406 0 .74.118 1 .355.259.236.39.541.39.914v2.526c0 .418-.128.745-.382.983-.256.238-.606.358-1.053.358-.429 0-.773-.124-1.032-.368-.256-.246-.387-.577-.387-.993V8.857c0-.38.133-.682.398-.905zm.72 3.842c.069.073.169.11.299.11a.444.444 0 0 0 .317-.112.41.41 0 0 0 .118-.31V8.82a.32.32 0 0 0-.12-.259.48.48 0 0 0-.315-.098.428.428 0 0 0-.293.098.33.33 0 0 0-.112.26v2.663c0 .134.036.237.105.31zm5.336.833h-.983v-.54a2.07 2.07 0 0 1-.565.455 1.212 1.212 0 0 1-.57.156c-.229 0-.398-.073-.514-.218-.114-.146-.172-.364-.172-.656V7.738h.98v3.748c0 .116.023.2.064.252.04.051.108.078.2.078a.567.567 0 0 0 .274-.103c.11-.069.212-.157.303-.264v-3.71h.983v4.888zM10.958 17.3h1.017v-.874H8.957v.874h1.017v5.142h.984V17.3zm3.02 5.142h.873v-4.439h-.872v3.372a1.23 1.23 0 0 1-.271.238.493.493 0 0 1-.244.093c-.081 0-.14-.023-.18-.07-.034-.047-.053-.123-.053-.228v-3.405h-.872v3.711c0 .265.052.462.152.595.104.133.254.198.457.198.164 0 .332-.046.507-.142a1.87 1.87 0 0 0 .504-.411v.488zm3.834-.195c.137-.167.205-.408.205-.722v-2.463c0-.363-.072-.64-.22-.83-.144-.188-.354-.283-.632-.283a.85.85 0 0 0-.402.106c-.131.07-.255.173-.374.308v-1.937h-.882v6.016h.882v-.34c.114.136.24.236.373.3.133.065.285.096.456.096.259 0 .458-.082.594-.25zm-1.058-3.593c.118 0 .209.039.272.115.062.078.092.192.092.342v2.292c0 .142-.026.243-.076.305-.05.064-.128.095-.235.095a.489.489 0 0 1-.21-.048.735.735 0 0 1-.208-.157v-2.765a.643.643 0 0 1 .18-.136.413.413 0 0 1 .185-.043zm2.62 1.675h1.67v-1.132c0-.42-.108-.743-.322-.967-.214-.224-.522-.337-.921-.337-.392 0-.71.121-.956.363s-.37.558-.37.941v1.994c0 .427.113.763.337 1.006.224.245.533.366.923.366.435 0 .762-.114.98-.343.22-.231.328-.574.328-1.03v-.227h-.898v.202c0 .261-.03.43-.087.506-.057.077-.158.115-.303.115-.14 0-.237-.044-.296-.134-.057-.091-.085-.253-.085-.487v-.836zm.09-1.537c.06-.083.16-.122.3-.122.132 0 .23.04.29.122.06.078.091.212.091.398v.448h-.77v-.448c0-.186.028-.32.09-.398z"></path>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  className="link-instagram"
                  href="https://www.instagram.com/healthspan.uk/"
                  title="Healthspan Instagram "
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                >
                  Healthspan Instagram
                  <svg id="icon-instagram" viewBox="0 0 30 30">
                    <path d="M21.103 22.627H8.897l-.097-.015a1.65 1.65 0 0 1-1.385-1.26c-.017-.076-.028-.155-.042-.232V8.88l.014-.085A1.645 1.645 0 0 1 8.66 7.412c.072-.016.147-.026.22-.04h12.24c.028.006.056.012.085.016a1.649 1.649 0 0 1 1.39 1.309c.013.066.022.133.032.2v12.206c-.01.068-.02.137-.033.204a1.65 1.65 0 0 1-1.254 1.279c-.078.017-.158.028-.237.041zM19.636 11.29v-.003c.25 0 .502.005.753-.001a.612.612 0 0 0 .587-.608V9.232a.616.616 0 0 0-.619-.62h-1.44a.617.617 0 0 0-.62.62c0 .478 0 .955.002 1.433 0 .071.014.145.037.213.086.254.32.41.604.411h.696zM15 11.91a3.09 3.09 0 1 0-.002 6.18A3.09 3.09 0 0 0 15 11.91zm-5.977 1.649v6.814c0 .324.281.604.606.604h10.74a.617.617 0 0 0 .607-.606v-6.811H19.52a4.77 4.77 0 0 1 .188 2.006 4.665 4.665 0 0 1-.658 1.902 4.742 4.742 0 0 1-6.363 1.673 4.633 4.633 0 0 1-1.843-1.856c-.645-1.188-.748-2.434-.37-3.727H9.024z"></path>
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-service-holder">
        <div className="frame">
          <div className="footer-service-section">
            <div className="d-md-inline-flex">
              <a className="phone-number" href="tel:08007312377">
                <span className="icon-footer icon-phone-white">
                  <svg className="default-state" width="28" height="28">
                    <svg id="icon-phone-white" viewBox="0 0 28 28">
                      <path
                        fill="#FFF"
                        fillRule="nonzero"
                        d="M18.31 16.473a3.524 3.524 0 0 1 4.982 0l2.676 2.677a3.523 3.523 0 0 1 0 4.983L24.5 25.601a4.784 4.784 0 0 1-6.02.605A59.677 59.677 0 0 1 1.794 9.52a4.78 4.78 0 0 1 .605-6.02l1.468-1.469a3.523 3.523 0 0 1 4.983 0l2.677 2.677a3.524 3.524 0 0 1 0 4.982l-.247.246a59.229 59.229 0 0 0 6.782 6.783l.246-.247zm-8.197-8.196a1.524 1.524 0 0 0 0-2.154L7.436 3.446a1.523 1.523 0 0 0-2.154 0L3.815 4.914a2.78 2.78 0 0 0-.351 3.504 57.676 57.676 0 0 0 16.119 16.12c1.104.73 2.57.583 3.503-.35l1.468-1.469a1.523 1.523 0 0 0 0-2.154l-2.676-2.677a1.524 1.524 0 0 0-2.155 0l-.892.892a1 1 0 0 1-1.34.066 60.866 60.866 0 0 1-8.336-8.336 1 1 0 0 1 .066-1.341l.892-.892z"
                      ></path>
                    </svg>
                  </svg>
                  <svg className="hover-state" width="28" height="28">
                    <svg id="icon-phone-white-hover" viewBox="0 0 28 28">
                      <path
                        fill="#FFF"
                        fillRule="nonzero"
                        d="M18.31 16.473a3.524 3.524 0 0 1 4.982 0l2.676 2.677a3.523 3.523 0 0 1 0 4.983L24.5 25.601a4.784 4.784 0 0 1-6.02.605A59.677 59.677 0 0 1 1.794 9.52a4.78 4.78 0 0 1 .605-6.02l1.468-1.469a3.523 3.523 0 0 1 4.983 0l2.677 2.677a3.524 3.524 0 0 1 0 4.982l-.247.246a59.229 59.229 0 0 0 6.782 6.783l.246-.247z"
                      ></path>
                    </svg>
                  </svg>
                </span>
                0800 73 123 77
              </a>
              <span>(9am till 6pm 7 days a week)</span>
            </div>

            <div className="d-md-inline-flex">
              <span className="register-interest">
                Register your interest for{" "}
                <Link className="nav-action-sm" role="button" to="/job-alerts">
                  job alerts
                </Link>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="container">
      <div className="sub-footer">
        <div className="footer-additional-holder">
          <div className="frame">
            <div className="footer-additional-section">
              <div className="copy-holder">
                <div className="copy">© Healthspan 2020</div>
                <address>
                  PO BOX 64, St Peter Port, Guernsey, GY1 3BT, United Kingdom
                </address>
              </div>
              <ul className="footer-additional-menu">
                <li>
                  <a
                    title="Privacy Notice"
                    href="https://www.healthspan.co.uk/privacy-notice"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Notice
                  </a>
                </li>

                <li>
                  <a
                    title="Cookie Policy"
                    href="https://www.healthspan.co.uk/cookie-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Cookie Policy
                  </a>
                </li>

                <li>
                  <a
                    title="Terms &amp; Conditions"
                    target="_blank"
                    href="https://www.healthspan.co.uk/terms-and-conditions"
                    rel="noopener noreferrer"
                  >
                    Terms &amp; Conditions
                  </a>
                </li>

                <li>
                  <a
                    title="Modern Slavery Statement"
                    target="_blank"
                    href="https://www.healthspan.co.uk/Modern-slavery-statement"
                    rel="noopener noreferrer"
                  >
                    Modern Slavery Statement
                  </a>
                </li>
              </ul>
              <ul className="footer-bottom-links">
                <li className="feefo-logo-footer">
                  <a
                    href="https://www.healthspan.co.uk/reviews"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    title="Reviews"
                  >
                    <img
                      src="https://cdn1.accropress.com/Healthspan/feefo-footer.png"
                      alt="Feefo"
                      width="245"
                      height="46"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.healthspan.co.uk/how-does-healthspan-ensure-credit-card-security"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    title="Credit card security"
                  >
                    <img
                      src="https://cdn1.accropress.com/Healthspan/secure-logo.png"
                      alt="Comodo Secure"
                      width="220"
                      height="46"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.healthspan.co.uk/buying-supplements-what-to-look-out-for"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    title="Buying supplements what to look out for"
                  >
                    <img
                      src="https://cdn1.accropress.com/Healthspan/sustainable-logo.png"
                      alt="Sustaibnable"
                      width="228"
                      height="46"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
)

export default Footer
